import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AddressObject } from '@shared/models/fe-experience.model';
import { IconService, MapLocation, MapService } from '@ess-front/shared';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'ess-experience-map',
  templateUrl: './experience-map.component.html',
  styleUrls: ['./experience-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExperienceMapComponent implements AfterViewInit {
  @Input() address: AddressObject | null = null;
  @Input() icon: string | null = null;

  distanceIcon: SafeHtml | null;
  websiteIcon: SafeHtml | null;

  @ViewChild('mapContainer') mapContainer: ElementRef | null = null;
  mapUrl: string | null = null;

  constructor(
    private mapService: MapService,
    private iconService: IconService,
  ) {
    this.distanceIcon = this.iconService.getSVG('distance');
    this.websiteIcon = this.iconService.getSVG('link');
  }

  ngAfterViewInit() {
    if (this.address?.location && this.mapContainer?.nativeElement) {
      const marker: MapLocation = { ...this.address.location };
      if (this.icon) marker.icon = this.icon;
      this.mapService.createMap(this.mapContainer.nativeElement, [marker], {
        zoom: 13,
        icons: { iconSize: { x: 60, y: 60 } },
        allowMarkerSelection: false,
      });
    }
  }

  navigateToGoogleMaps() {
    if (!this.address?.mapsUrl) return;
    window.open(this.address.mapsUrl, '_blank');
  }
}
